import React from "react"
import { Link } from "gatsby"
import { Card } from "react-bootstrap"
import Img from "gatsby-image"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import "./style.scss"

export default ({
  slug,
  title,
  fullName,
  imageThumb,
  imageFeatured,
  imageAlt = "Missing Alt Text",
}) => (
  <Link to={slug ? `/first-responders/staff/${slug}` : ""}>
    <Card className="staff-cards">
      <Img
        key={"img-thumb-" + imageThumb.childImageSharp.fixed.originalName}
        loading={"lazy"}
        fixed={imageThumb.childImageSharp.fixed}
        alt={imageAlt}
      />
      <Card.Body>
        <Card.Title className={"pt-3"}>{fullName}</Card.Title>
        <Card.Text className={"position pb-2"}>{title}</Card.Text>
        <Card.Text className={"pb-3"}>
          <FontAwesomeIcon className="mr-2" icon={"arrow-right"} />
          Read Bio
        </Card.Text>
      </Card.Body>
    </Card>
  </Link>
)
